import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { DocumentCategory } from '@core/enums';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;

  find(category: DocumentCategory): Observable<any> {
    return this._http.get(`${this._apiUrl}/documents/fetch/${category}`);
  }

  upload(formData: FormData): Observable<any> {
    return this._http.post(`${this._apiUrl}/documents/insert`, formData);
  }

  move(data: any): Observable<any> {
    return this._http.post(`${this._apiUrl}/documents/move`, data);
  }

  delete(documentId: number): Observable<any> {
    return this._http.delete(`${this._apiUrl}/documents/delete/${documentId}`);
  }

  download(name: string): Observable<any> {
    return this._http.post(`${this._apiUrl}/get-documentbyname`, { name }, { responseType: 'blob' });
  }
}
